import type { InputHTMLAttributes } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  id: string;
};

export function Input({ label, id, className = "", ...rest }: Props) {
  return (
    <div className="flex flex-col gap-1.5 text-left">
      <label htmlFor={id} className="text-xs font-medium tracking-wide text-obsidian/60">
        {label}
      </label>
      <input
        id={id}
        className={`w-full rounded-xl border border-slate-200 bg-white/90 px-4 py-3 text-charcoal placeholder:text-slate-400 outline-none transition-colors duration-200 focus:border-gold focus:bg-white ${className}`}
        {...rest}
      />
    </div>
  );
}
